import backendUrl from "./backendUrl";

export const adminApi = {
  getDetailedAnalytics: {
    url: `${backendUrl}/api/detailed-analytics`,
    method: "GET",
  },
  getSalesReport: {
    url: `${backendUrl}/api/sales-report`,
    method: "GET",
  },
  dashboardStats: {
    url: `${backendUrl}/api/dashboard-stats`,
    method: "GET",
  },
};
